<template>
    <FormMainContainer :title="$t('adviser_appointment_type.title')"
                       :previous-step-route="homeUrl">
        <AdviserAppointmentTypeSelection :paths="paths" />
    </FormMainContainer>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import FormMainContainer from "~concierge/components/FormMainContainer.vue";
import HeaderSection from "~concierge/components/HeaderSection.vue";
import FooterSection from "~concierge/components/FooterSection.vue";
import AdviserAppointmentTypeSelection from "~concierge/components/AdviserAppointmentTypeSelection.vue";
import { SelectAdviserAppointmentPathData } from "~types/concierge";

export default defineComponent({
    components: { HeaderSection, FooterSection, AdviserAppointmentTypeSelection, FormMainContainer },
    props: {
        paths: {
            type: Object as PropType<SelectAdviserAppointmentPathData[]>,
            required: true,
        },
        homeUrl: {
            type: String,
            required: true
        },
    },
});
</script>
